export enum ProductType {
    TourProduct = 'TourProduct',
    HotelOfferProduct = 'HotelOfferProduct',
    RailwayTourProduct = 'RailwayTourProduct',
}
